import { Injectable } from '@angular/core';
import { UserData } from '../../content/interfaces/user-data';
import { BaseCrudService } from './base-crud.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseCrudService<any, UserData>{

  constructor() {
    super();
  }
  
}
